import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import AboutUs from "./sections/AboutUs";
import OurServices from "./sections/OurServices";
import HowItWorks from "./sections/HowItWorks";
import ClientTestimonials from "./sections/ClientTestimonials";
import Footer from "@/reusable_sections/Footer";
import FeatureAdvantage from "./sections/FeatureAdvantage";
import AboutMe from "./sections/AboutMe";
import ServiceArea from "./sections/ServiceArea";
import FrequentlyAskedQuestions from "./sections/FrequentlyAskedQuestions";
import FreeTrial from "./sections/FreeTrial";
import FundSearch from "./sections/FundSearch";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <AboutUs />
      <HowItWorks />
      <AboutMe />
      <OurServices />
      <FeatureAdvantage />
      <FundSearch />
      <ServiceArea />
      <FrequentlyAskedQuestions />
      <FreeTrial />
      <ClientTestimonials />
      <Footer />
    </div>;
}